import React from 'react';
// import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

let IconFanFeed = (props) => {
  props = Object.assign({viewBox: '0 0 30 30'}, props);
  return (
    <SvgIcon {...props}>
      <g>
        <path d="M10.5,9.7c-0.2-0.2-0.6-0.2-0.8,0c-1.6,1.5-2.6,3.6-2.6,5.8c0,2.2,0.9,4.3,2.6,5.8c0.1,0.1,0.2,0.1,0.4,0.1
		c0.2,0,0.3-0.1,0.4-0.2c0.2-0.2,0.2-0.6,0-0.8c-1.4-1.3-2.2-3.1-2.2-5c0-1.9,0.8-3.7,2.2-5C10.7,10.3,10.7,9.9,10.5,9.7z"/>
        <path d="M5.8,5.6c-0.2-0.2-0.6-0.2-0.8,0C2.4,8.3,1,11.8,1,15.5c0,3.7,1.4,7.3,4.1,9.9c0.1,0.1,0.3,0.2,0.4,0.2
		c0.1,0,0.3-0.1,0.4-0.2c0.2-0.2,0.2-0.6,0-0.8c-2.4-2.4-3.7-5.7-3.7-9.1c0-3.4,1.3-6.7,3.8-9.1C6.1,6.2,6.1,5.8,5.8,5.6z"/>
        <path d="M19.5,9.7c-0.2,0.2-0.2,0.6,0,0.8c1.4,1.3,2.2,3.1,2.2,5c0,1.9-0.8,3.7-2.2,5c-0.2,0.2-0.2,0.6,0,0.8
		c0.1,0.1,0.3,0.2,0.4,0.2c0.1,0,0.3,0,0.4-0.1c1.6-1.5,2.6-3.6,2.6-5.8c0-2.2-0.9-4.3-2.6-5.8C20,9.5,19.7,9.5,19.5,9.7z"/>
        <path d="M15,12.7c-1.5,0-2.8,1.3-2.8,2.8c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8C17.8,14,16.5,12.7,15,12.7z
		 M15,17.2c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7s1.7,0.8,1.7,1.7C16.7,16.4,15.9,17.2,15,17.2z"/>
        <path d="M25,5.6c-0.2-0.2-0.6-0.2-0.8,0c-0.2,0.2-0.2,0.6,0,0.8c2.4,2.4,3.7,5.7,3.7,9.1c0,3.4-1.3,6.7-3.8,9.1
		c-0.2,0.2-0.2,0.6,0,0.8c0.1,0.1,0.3,0.2,0.4,0.2c0.1,0,0.3-0.1,0.4-0.2c2.6-2.6,4.1-6.2,4.1-9.9C29,11.8,27.6,8.2,25,5.6z"/>
      </g>
    </SvgIcon>
  );
};

IconFanFeed.displayName = 'IconFanFeed';
IconFanFeed.muiName = 'SvgIcon';

export default IconFanFeed;



// WEBPACK FOOTER //
// ./src/components/Icons/IconFanFeed.js